import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const ImpactCategoryCreateSchema = Yup.object().shape({
    title: Yup.string().required('This value is required'),
    description: Yup.string().nullable(),
});

export default function GeneralRiskImpactCategoryCreateForm(props) {
    return (
        <Formik
            initialValues={{
                title: '',
                description: '',
            }}
            validationSchema={ImpactCategoryCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .post(props.storeUrl, values)
                    .then((res) => {
                        props.onSuccess();
                        actions.resetForm();
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Title')}
                            type="text"
                            required={true}
                            name="title"
                            placeholder={$t('Enter risk impact category title')}
                        ></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Description')}
                            as="textarea"
                            type="text"
                            name="description"
                            placeholder={$t('Enter risk impact category description')}
                        ></TextareaFormField>
                    </div>
                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Save')}
                        onCancel={props.onCancel}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
